module.exports = __webpack_public_path__ + "img/chenghong.ba49567e.png";